import { render, staticRenderFns } from "./adiponectinPdf.vue?vue&type=template&id=884cfa38&scoped=true&"
import script from "./adiponectinPdf.vue?vue&type=script&lang=js&"
export * from "./adiponectinPdf.vue?vue&type=script&lang=js&"
import style0 from "./adiponectinPdf.vue?vue&type=style&index=0&id=884cfa38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884cfa38",
  null
  
)

export default component.exports